// extracted by mini-css-extract-plugin
export var button = "SliderNavigation-module--button--dc9b3";
export var buttonNext = "SliderNavigation-module--buttonNext--955b6";
export var buttonPrev = "SliderNavigation-module--buttonPrev--9046e";